import { toast } from 'sonner';

import { ticketErrorRO } from '../ticketCopy';
import { useAssignTicketMutation } from '../tickets.api';

import { AssigneePicker, type AssigneeValue } from './AssigneePicker';

export function TicketAssigneeChanger({ id, value }: { id: number; value: AssigneeValue }) {
    const [assign, { isLoading }] = useAssignTicketMutation();

    const change = async (v: AssigneeValue) => {
        try {
            await assign({
                id,
                assigneeUserId: v ? v.assigneeUserId : null,
                assigneeName: v ? v.assigneeName : null,
            }).unwrap();
            toast.success('Atribuire actualizata.');
        } catch (e) {
            toast.error(ticketErrorRO(e, 'Eroare la atribuire.'));
        }
    };

    return <AssigneePicker value={value} onChange={change} disabled={isLoading} />;
}
